import { Hidden, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { TableLayoutWithDetail } from "../../layout/TableLayoutWithDetail";
import {
  columnsByStartup,
  columnsDetail,
} from "../../helpers/columns/columnsPosition.js";
import { useCallback } from "react";

export const PositionsTable = ({ rows }) => {
  const startupList = rows.map((alias) => alias.alias);
  const startupListNoRepeat = startupList.filter((item, index) => {
    return startupList.indexOf(item) === index;
  });
  const objByStartup = startupListNoRepeat.map((startup) => {
    return {
      id: startup,
      startup,
      data: rows.filter((investment) => investment.alias === startup),
    };
  });
  const { t } = useTranslation("global");

  const ViewDetails = useCallback(
    (investment) => {
      const detailRows = [];
      investment.data.forEach((inv) => {
        // 1. Push the investment row
        detailRows.push({
          ...inv,
          id: `inv-${inv.id}`,
          rowType: "investment"
        });

        // 2. Push a row for each dividend event
        if (inv.dividends && inv.dividends.length > 0) {
          inv.dividends.forEach((div, index) => {
            const sharesVal = inv.amount / inv.participationValuation;
            detailRows.push({
              id: `div-${inv.id}-${div.id || index}`,
              rowType: "dividend",
              investmentDate: div.dividendDate, // "Fecha operación"
              roundNumber: "-",
              amount: null,
              participationValuation: null,
              sharesAmount: sharesVal, // "Nº de participaciones"
              dividendPerShare: div.amount / sharesVal, // "Dividendo por participación"
              amountDividend: div.amount, // "Dividendo total"
              vehicle: inv.vehicle,
              whoInvests: inv.whoInvests,
              investmentType: "Dividendo"
            });
          });
        }
      });

      return (
        <Stack>
          <DataGridPro
            density="compact"
            autoHeight
            columns={columnsDetail(t)}
            rows={detailRows}
            sx={{ flex: 1 }}
            hideFooter
          />
        </Stack>
      );
    },
    [t]
  );

  return (
    <Hidden mdDown>
      <TableLayoutWithDetail
        rows={objByStartup}
        columns={columnsByStartup(t)}
        title="positionsClub"
        detail={ViewDetails}
      />
    </Hidden>
  );
};
